import { Component, OnInit, Input } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Campaign } from '../shared/models/campaign';
import { LiveUpdateService } from '../shared/live-update.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { IEmail } from '../sign-up-flyout/sign-up-flyout.component';

export interface IEmail {
  emailAddress: string;
  firstName: string;
  lastName: string;
  zipCode: string;
  quote?: string;
  phone?: string;
  date?: string;
  }

@Component({
  selector: 'ae-cms-campaign',
  templateUrl: './cms-campaign.component.html',
  styles: []
})
export class CmsCampaignComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  public activeDate: Date;
  public campaignTemp: Campaign;
  public error: string;
  public campaigns: Campaign[];
  public shadowCampaign: Campaign[];
  public emails: IEmail[];
  public quotes: IEmail[];

  constructor(
    private liveUpdateService: LiveUpdateService,
    private datePipe: DatePipe,
    private auth: AngularFireAuth,
    private route: Router) { }

  ngOnInit() {
    this.campaignTemp = {
      itemKey: '',
      disabled: false,
      date: new Date(),
      active: true,
      description: '',
      heading: '',
      subHeading: '',
      isCancel: false
    };

    this.liveUpdateService.campaigns$.subscribe((campaigns: Campaign[]) => {
      this.campaigns = campaigns;
      this.shadowCampaign = campaigns;
    });

    this.liveUpdateService.emails$.subscribe((email: IEmail[]) => {
      this.emails = email;
    });

    this.liveUpdateService.quotes$.subscribe((quote: IEmail[]) => {
      this.quotes = quote;
    });

    this.liveUpdateService.getCampaigns();
    this.liveUpdateService.getEmails();
    this.liveUpdateService.getQuotes();
  }

  submitCampaign() {
    const user = JSON.parse(localStorage.getItem('auth_user'));
    this.campaignTemp.uId = user.user.uid.toString();
    if (this.campaignTemp.active
      && this.campaignTemp.date
      && this.campaignTemp.description
      && this.campaignTemp.displayNumber
      && this.campaignTemp.subHeading) {
      this.error = null;
      this.campaignTemp.readonly = true;
      this.campaignTemp.stringDate = this.datePipe.transform(this.campaignTemp.date.toString(), 'shortDate');
      this.liveUpdateService.createItem(this.campaignTemp);
    } else {
      this.error = 'There was an error on the page. Please review and re-submit request.';
    }
  }

  signOut() {
    this.auth.auth.signOut();
    localStorage.clear();
    this.route.navigate(['']);
  }

  deleteRecord(key: string) {
    this.liveUpdateService.deleteQuoteRecord(key);
  }
}
